<template>
  <ol class="dd-list">
    <li v-for="item in dataList" :key="item.id" class="dd-item" :data-id="item.id">
      <template v-if="collapsable && item[childItemField] && item[childItemField].length > 0">
        <button type="button" v-if="item.collapsed" class="nested-toggle-button" @click.prevent="item.collapsed = !item.collapsed"><i class="fas fa-expand"></i></button>
        <button type="button" v-if="!item.collapsed" class="nested-toggle-button" @click.prevent="item.collapsed = !item.collapsed"><i class="fas fa-collapse"></i></button>
      </template>
      <div class="dd-handle-base" :class="[editingOrder ? 'dd-handle' : '']">
        <i class="far fa-bars" v-if="editingOrder"> </i>
        <slot name="itemSlot" v-bind:item="item" />
      </div>
      <NestedDataList v-if="item[childItemField] && !item.collapsed" :listTree="item[childItemField]" :editingOrder="editingOrder" :collapsable="collapsable" :childItemField="childItemField">
        <template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="scope">
          <slot :name="slot" v-bind="scope"/>
        </template>
      </NestedDataList>
    </li>
  </ol>
</template>

<style lang="scss">
.dd-handle-base {
  display: block;
  margin: 5px 0;
  padding: 5px 10px;
  text-decoration: none;
  background: #f0f0f0;
  -webkit-border-radius: $control-border-radius;
  border-radius: $control-border-radius;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.dd-item > .nested-toggle-button {
  color: #b0b0b0;
  font-size: 20px;
}
</style>

<script>
import _ from 'lodash'

export default {
  name: "NestedDataList",
  components: {
  },
  props: {
    listTree: Array,
    editingOrder: Boolean,
    childItemField: {
      type: String,
      default: 'children'
    },
    collapsable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataList: []
    }
  },
  watch: {
    listTree: {
      immediate: true,
      handler: function(newVal, oldVal) {
        this.$data.dataList = _.cloneDeep(newVal)
      }
    }
  }
};
</script>
